import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'
import { Injectable } from '@tanbo/vue-di-plugin'

export { getPeripheralTypeLabel, PERIPHERAL_TYPE_VALUES } from '../../peripheral-type-i18n'

export interface RequestParams {
  /** 页码（最小页码：1） */
  page: number
  /** 每页数量 */
  limit: number
  /** 排序字段 累计外设计入次数：access_count（默认），设备ID：peripheral_id，设备类型：peripheral_type，设备名称:peripheral_name */
  sort_key: string
  /** 排序,true-正序，false-倒序 */
  asc: boolean
  /** 查询关键词 */
  search_word: string
  /** 时间范围 1：全部 ，2：最近24小时 （默认），3：最近7天 ，4：近一个月 */
  time_range: number
  /** 策略 id（与设备视图列表页嵌入场景一致时可选，由后端是否支持） */
  strategy_id?: string
  /** 设备类型，与概览 peripheral_type 一致（可选） */
  peripheral_type?: number
}

export interface DeviceItem {
  /** 设备ID */
  peripheral_id: string
  /** 设备类型 */
  peripheral_type: number
  /** 设备名称 */
  peripheral_name: string
  /** 接入终端数 */
  access_device_count: number
}

export interface ResponseData {
  /** 终端视图信息列表 */
  list: DeviceItem[]
  /** 总数 */
  total: number
}

export interface TerminalRequestParams {
  /** 设备id */
  peripheral_id: string
  /** 时间范围 1：全部 ，2：最近24小时 （默认），3：最近7天 ，4：近一个月 */
  time_range: number
}

@Injectable()
export class EquipmentViewService {
  constructor (private http: Http) {
  }

  @ParamsClean()
  @InvokeThrottle()
  getPeripheralcontrolViewTerminalGet (data: RequestParams) {
    return this.http.post<ResponseData>('/peripheralcontrol/view/peripheral/get', data)
  }

  @InvokeThrottle()
  getPeripheralcontrolViewPeripheralAccessedRecordsGet (data: TerminalRequestParams) {
    return this.http.post<{
      /** 设备信息列表 */
      list: DeviceItem[]
    }>('/peripheralcontrol/view/peripheral/accessed-records/get', data)
  }

  download (type: 0 | 1, options: Partial<RequestParams>, moduleName: string) {
    const params = Object.assign({}, options, {
      file_type: type,
      page: 1,
      limit: 9999999,
    })
    return this.http.downloadWithBlob('/peripheralcontrol/view/peripheral/export', params, moduleName)
  }
}
